export const RECAPTCHA_SCORE_THRESHOLD = 0.5;
export const RECAPTCHA_TOKEN_SUBSTRING_LENGTH = 20;
export const RECAPTCHA_TOKEN_ELLIPSIS = "...";
export const RECAPTCHA_MOCK_TOKEN_PREFIX = "localhost-mock-token";
export const RECAPTCHA_TOKEN_MIN_LENGTH = 80;
export const RECAPTCHA_TOKEN_PATTERN = /^[A-Za-z0-9._-]+$/;

const API_BASE_URL = import.meta.env.VITE_API_URL || "https://api-qas.talk2buy.com.br";

// TEMPORÁRIO: Usando sempre QAS para reCAPTCHA pois API de produção está com problemas
//
// PARA REVERTER QUANDO A API DE PRODUÇÃO VOLTAR:
// 1. Remover a linha VITE_RECAPTCHA_VERIFY_URL do arquivo .env
// 2. A aplicação voltará a usar automaticamente a API baseada no VITE_API_URL
//
// Para voltar ao normal, remover VITE_RECAPTCHA_VERIFY_URL do .env
const RECAPTCHA_VERIFY_URL =
  import.meta.env.VITE_RECAPTCHA_VERIFY_URL || `${API_BASE_URL}/api/v1/recaptcha/verify`;

export const RECAPTCHA_ENDPOINTS = {
  API_VERIFY: RECAPTCHA_VERIFY_URL,
  GOOGLE_SITEVERIFY: "https://www.google.com/recaptcha/api/siteverify",
} as const;

export const RECAPTCHA_ACTIONS = {
  LOGIN: "login",
  REGISTER: "register",
  CONTACT: "contact",
  SUBMIT: "submit",
  RESET_PASSWORD: "reset_password",
  CHANGE_PASSWORD: "change_password",
} as const;

export const RECAPTCHA_ERROR_CODES = {
  MISSING_INPUT_RESPONSE: "missing-input-response",
  INVALID_INPUT_RESPONSE: "invalid-input-response",
  MISSING_INPUT_SECRET: "missing-input-secret",
  INVALID_INPUT_SECRET: "invalid-input-secret",
  BAD_REQUEST: "bad-request",
  TIMEOUT_OR_DUPLICATE: "timeout-or-duplicate",
  LOW_SCORE: "low-score",
  CONFIGURATION_ERROR: "configuration-error",
  SERVER_ERROR: "server-error",
  UNKNOWN_ERROR: "unknown-error",
} as const;

export const RECAPTCHA_HTTP_STATUS = {
  OK: 200,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  UNPROCESSABLE_ENTITY: 422,
  TOO_MANY_REQUESTS: 429,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
} as const;

export const RECAPTCHA_CONFIG = {
  SITE_KEY: import.meta.env.VITE_RECAPTCHA_SITE_KEY || "",
  SECRET_KEY: import.meta.env.VITE_RECAPTCHA_SECRET_KEY || "",
  MIN_SCORE: RECAPTCHA_SCORE_THRESHOLD,
  USE_RECAPTCHA_NET: true,
  HIDE_DEFAULT_BADGE: true,
  SCRIPT_PROPS: {
    async: true,
    defer: true,
    appendTo: "head" as const,
  },
} as const;

export const LOCALHOST_IDENTIFIERS = ["localhost", "127.0.0.1", "0.0.0.0", "[::1]"] as const;

export const DEVELOPMENT_PORTS = ["3000", "3001", "5173", "8080", "8000"] as const;

export {};
